module.exports = __webpack_public_path__ + "img/new_assur_app.bea8a83e.png";